import React, { Component } from 'react'
import { Trans } from '@lingui/react'

type Props = {
  finishedBooksCount: number
  promisedBooksCount?: number
}

export class ReadingProgressBarMessage extends Component<Props> {
  render(): JSX.Element {
    const { finishedBooksCount, promisedBooksCount } = this.props

    return promisedBooksCount ? (
      <Trans
        id="achievements.finished_and_promised_books_in_user_card"
        values={{
          finishedBooksCount,
          finishedBooksCountString: `${finishedBooksCount}`,
          promisedBooksCountString: `${promisedBooksCount}`,
        }}
      />
    ) : (
      <Trans
        id="achievements.only_finished_books_in_user_card"
        values={{
          finishedBooksCount,
          finishedBooksCountString: `${finishedBooksCount}`,
        }}
      />
    )
  }
}
